<template>
  <div class="navbar-form mr-sm-0 m-auto" id="loginForm">
    <div v-if="isLoggedIn">
      <p>Logged in as {{ this.$session.get("username") }}</p>
      <button type="button" @click="logout">Logg ut</button>
    </div>
    <div v-else class="input-group row no-gutters">
      <div class="col-8">
        <div class>
          <input
            class="form-control"
            type="text"
            v-model="username"
            id="username"
            placeholder="Brukernavn"
          />
        </div>
        <div class>
          <input
            class="form-control"
            type="password"
            v-model="password"
            id="password"
            placeholder="Passord"
          />
        </div>
      </div>
      <div class="col-4 input-group-btn">
        <button
          class="btn btn-outline-secondary btn-block py-4"
          type="button"
          @click="login"
        >
          Logg inn
        </button>
      </div>
      <p v-if="message">{{ message }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "login",
  props: {},
  data: function() {
    return {
      username: "",
      password: "",
      message: "",
      isLoggedIn: this.$session.has("token")
    };
  },
  beforeCreate: function() {},
  methods: {
    login() {
      if (this.username != "" && this.password != "") {
        this.APIpost("token-auth/", {
          username: this.username,
          password: this.password
        }).then(response => {
          if (response.status == 400) {
            this.message = "Feil brukernavn eller passord. Prøv igjen! ";
            return;
          }
          if (this.error) {
            this.message =
              "Det skjedde en feil under pålogging. Prøv igjen!" + this.error;
            return;
          }
          this.$session.start();
          this.$session.set("token", response.data.token);
          this.$session.set("username", this.username);
          this.$emit("changeLoginStatus", true);
          this.username = "";
          this.password = "";
          this.message = "";
          this.isLoggedIn = true;
          this.$router.go();
        });
      } else {
        this.message = "Brukernavn og passord kan ikke være tomme";
      }
    },
    logout() {
      this.$session.destroy();
      this.isLoggedIn = false;
      this.message = "Du er nå logget ut!";
      this.$emit("changeLoginStatus", false);
      this.$router.go();
      //this.$router.push("/");
    }
  }
};
</script>
<style>
#loginForm {
  max-width: 300px;
}
.navbar-toggler {
  border: 0px !important;
}
</style>
